import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { OperacionUnitariaSchema } from "./OperacionUnitariaSchema";

export const ResiduoSolidoUrbanoSchema = yup.object().shape({
  orden: yup.number().required("errors.residuoSolidoUrbano.orden.required"),
  cantidad: CantidadSchema.required(
    "errors.residuoSolidoUrbano.cantidad.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "KG" } }),
  operacionesUnitarias: yup
    .array()
    .of(OperacionUnitariaSchema)
    .min(1, "errors.residuoSolidoUrbano.operacionesUnitarias.min")
    .required("errors.residuoSolidoUrbano.operacionesUnitarias.required")
    .default([]),
  descripcion: yup
    .string()
    .max(100, "errors.residuoSolidoUrbano.descripcion.max")
    .required("errors.residuoSolidoUrbano.descripcion.required")
    .default(""),
  material: yup
    .object()
    .required("errors.residuoSolidoUrbano.material.required")
    .default(null),
  destino: yup
    .object()
    .required("errors.residuoSolidoUrbano.destino.required")
    .default(null),
});
